<template>
  <md-card-content>
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>請求書の送付方法</label>
      </div>
      <div class="md-layout-item md-small-size-100">
        <md-radio v-for="(billingViaName, billingViaCode) in billingViaWithFee"
                  v-model="form.bill_via" v-bind:key="'billing-via-key-' + billingViaCode"
                  :value="billingViaCode" required name="billingVia"
                  v-if="showViaItem(billingViaCode)" :disabled="!activated || sending">
          {{ billingViaName }}
        </md-radio>
      </div>
    </div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-20 md-small-size-100"></div>
      <div class="md-layout-item">
        <span class="md-caption">※クレジットカードでのお支払いの場合は、明細書をメールでお送りします。</span>
      </div>
    </div>

    <!-- ご連絡先-->
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100 md-form-title">
        <label>宛名</label>
      </div>
      <div class="md-layout-item">
        <div class="md-layout">
          <div class="md-layout-item">
            <md-field :class="getValidationClass('name1')">
              <label>法人名</label>
              <md-input required :disabled="!activated || sending" v-model="form.name1"></md-input>
              <span class="md-helper-text">例) 株式会社JON　上野オフィス</span>
              <span class="md-error" v-if="getValidationResponseMessage('name1')">
                {{ getValidationResponseMessage('name1') }}
              </span>
              <span class="md-error" v-else-if="!$v.form.name1.required">
                {{ errors.name1.required }}
              </span>
            </md-field>
          </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item">
            <span class="md-caption">
              ※法人名は省略せずにご入力ください。×(株)　〇株式会社<br/>
            </span>
          </div>
        </div>
      </div>
      <div class="md-layout-item">
        <md-field :class="getValidationClass('name2')">
          <label>部署名</label>
          <md-input :disabled="!activated || sending" v-model="form.name2"></md-input>
          <span class="md-helper-text">例) 経理部</span>
          <span class="md-error" v-if="getValidationResponseMessage('name2')">
            {{ getValidationResponseMessage('name2') }}
          </span>
        </md-field>
      </div>
    </div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-20 md-small-size-100"></div>
      <div class="md-layout-item md-size-40 md-small-size-100">
        <md-field :class="getValidationClass('name3')">
          <label>ご担当者名</label>
          <md-input :disabled="!activated || sending" v-model="form.name3"></md-input>
          <span class="md-helper-text">例) JON 太郎</span>
          <span class="md-error" v-if="getValidationResponseMessage('name3')">
            {{ getValidationResponseMessage('name3') }}
          </span>
        </md-field>
      </div>
    </div>

    <!-- 所在地-->
    <div class="md-layout md-gutter" v-if="form.bill_via !== common.billingViaEmail">
      <div class="md-layout md-layout-item md-alignment-bottom-left md-size-20 md-small-size-100">
        <label>所在地</label>
        <div class="md-layout-item md-size-100">
          <md-button class="md-primary md-raised check-same-corp" :disabled="!activated || sending"
                     @click="toggleSameCorporation()">
            <md-icon v-if="form.isSameCorporation">check_box</md-icon>
            <md-icon v-else>check_box_outline_blank</md-icon>
            <span>法人情報と同じ</span>
          </md-button>
        </div>
      </div>
      <div class="md-layout-item md-size-30 md-small-size-100">
        <md-field :class="getValidationClass('postal')">
          <label>郵便番号</label>
          <span class="md-prefix">〒</span>
          <md-input required :disabled="!activated || sending || form.isSameCorporation"
                    v-model="form.postal"></md-input>
          <span class="md-helper-text">例) 1076231、ハイフン不要</span>
          <span class="md-error" v-if="getValidationResponseMessage('postal')">
            {{ getValidationResponseMessage('postal') }}
          </span>
          <span class="md-error" v-else-if="!$v.form.postal.requiredIf">
            {{ errors.postal.requiredIf }}
          </span>
          <span class="md-error" v-else-if="!$v.form.postal.numeric">
            {{ errors.postal.numeric }}
          </span>
        </md-field>
      </div>
    </div>
    <div class="md-layout md-gutter" v-if="form.bill_via !== common.billingViaEmail">
      <div class="md-layout-item md-size-20 md-small-size-100"></div>
      <div class="md-layout-item md-size-25 md-small-size-50">
        <md-field>
          <label>都道府県</label>
          <md-select id="pref" required :disabled="!activated || sending || form.isSameCorporation" v-model="form.pref">
            <md-option v-for="(pref,index) in prefectures" :value="pref" :key="'pref-' + index">
              {{ pref }}
            </md-option>
          </md-select>
          <span class="md-helper-text">例) 東京都</span>
          <span class="md-error" v-if="getValidationResponseMessage('pref')">
            {{ getValidationResponseMessage('pref') }}
          </span>
          <span class="md-error" v-else-if="!$v.form.pref.requiredIf">
            {{ errors.pref.requiredIf }}
          </span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-35 md-small-size-50">
        <md-field :class="getValidationClass('city')">
          <label>市区町村</label>
          <md-input type="text" required :disabled="!activated || sending || form.isSameCorporation"
                    v-model="form.city"></md-input>
          <span class="md-helper-text">例) 新宿区</span>
          <span class="md-error" v-if="getValidationResponseMessage('city')">
            {{ getValidationResponseMessage('city') }}
          </span>
          <span class="md-error" v-else-if="!$v.form.city.requiredIf">
            {{ errors.city.requiredIf }}
          </span>
        </md-field>
      </div>
    </div>
    <div class="md-layout md-gutter" v-if="form.bill_via !== common.billingViaEmail">
      <div class="md-layout-item md-size-20 md-small-size-100"></div>
      <div class="md-layout-item md-size-40 md-small-size-50">
        <md-field :class="getValidationClass('street_name')">
          <label>町名</label>
          <md-input type="text" required :disabled="!activated || sending || form.isSameCorporation"
                    v-model="form.street_name"></md-input>
          <span class="md-helper-text">例) 新小川町</span>
          <span class="md-error"
                v-if="getValidationResponseMessage('street_name')">{{
              getValidationResponseMessage('street_name')
            }}</span>
          <span class="md-error"
                v-else-if="!$v.form.street_name.requiredIf">{{ errors.street_name.requiredIf }}</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-40 md-small-size-50">
        <md-field :class="getValidationClass('street_number')">
          <label>番地</label>
          <md-input type="text" required :disabled="!activated || sending || form.isSameCorporation"
                    v-model="form.street_number"></md-input>
          <span class="md-helper-text">例) 5-1</span>
          <span class="md-error" v-if="getValidationResponseMessage('street_number')">
            {{ getValidationResponseMessage('street_number') }}
          </span>
          <span class="md-error" v-else-if="!$v.form.street_number.requiredIf">
            {{ errors.street_number.requiredIf }}
          </span>
        </md-field>
      </div>
    </div>
    <div class="md-layout md-gutter" v-if="form.bill_via !== common.billingViaEmail">
      <div class="md-layout-item md-size-20 md-small-size-100"></div>
      <div class="md-layout-item md-size-60 md-small-size-100">
        <md-field>
          <label>建物名・部屋番号等</label>
          <md-input :disabled="!activated || sending || form.isSameCorporation" v-model="form.etc"></md-input>
          <span class="md-helper-text">例) ニューリバー51</span>
        </md-field>
      </div>
    </div>

    <!-- メールアドレス-->
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>メールアドレス</label>
        <div class="md-caption">※請求書送付先に追加できるメールアドレスは10件までです。</div>
      </div>
      <div class="md-layout-item md-size-40 md-small-size-100">
        <md-field :class="getValidationClass('email')">
          <label>メールアドレス</label>
          <md-input name="mail" required :disabled="!activated || sending || form.isSameCorporation"
                    v-model="form.email"/>
          <span class="md-helper-text">例) jontaro@jon.co.jp</span>
          <span class="md-error" v-if="getValidationResponseMessage('email')">
            {{ getValidationResponseMessage('email') }}
          </span>
          <span class="md-error" v-else-if="!$v.form.email.required">
            {{ errors.email.required }}
          </span>
          <span class="md-error" v-else-if="!$v.form.email.email">
            {{ errors.email.email }}
          </span>
        </md-field>
      </div>
    </div>

    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
      </div>
      <div class="md-layout-item md-size-40 md-small-size-100">
        <div class="md-layout-item d-flex" v-for="(additionalAddressItem, index) in form.additionalAddresses"
             :key="'additionalAddresses_' + index">
          <div class="md-field d-block" style="padding-top: 0; margin: 0;">
            <md-field :class="getEmailValidationClass(index)">
              <label>メールアドレス</label>
              <md-input name="mail" v-model="form.additionalAddresses[index]" :disabled="!activated || sending" />
              <span class="md-helper-text">例) jontaro@jon.co.jp</span>
              <span class="md-error"
                    v-if="getEmailValidationResponseMessage(index)">{{ getEmailValidationResponseMessage(index) }}</span>
              <span class="md-error"
                    v-else-if="!$v.form.additionalAddresses.$each[index].email">{{ errors.email.email }}</span>
              <span class="md-error"
                    v-else-if="!$v.form.additionalAddresses.$each[index].duplicateWith">{{ errors.email.duplicated }}</span>
              <span class="md-error"
                    v-else-if="!$v.form.additionalAddresses.$each[index].duplicate">{{ errors.email.duplicated }}</span>
            </md-field>
          </div>
          <div class="d-flex align-items-end" style="height: 63px;">
            <div>
              <md-icon class="ml-3 pointer" @click.native="addNewEmail(index + 1)">add_circle_outline</md-icon>
              <!-- show when additionalAddresses >= 10-->
              <md-tooltip md-direction="top" v-if="form.additionalAddresses.length >= 10">追加できる件数は10件までです。</md-tooltip>
              <!--hover add button-->
              <md-tooltip md-direction="top" v-else>メールアドレスの追加</md-tooltip>
            </div>
          </div>
          <div class="d-flex align-items-end" style="height: 63px;">
            <div>
              <md-icon class="ml-3 pointer" @click.native="removeThisEmail(index)" v-show="form.additionalAddresses.length > 1">remove_circle_outline</md-icon>
              <md-tooltip>メールアドレスの削除</md-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </md-card-content>
</template>

<script>
import Common                                                       from "../../modules/common";
import CommonMixin                                                  from "../../mixins/commonMixin";
import ContractFormMixin                                            from "../../mixins/contractFormMixin";
import {validationMixin}                                            from "vuelidate";
import Validation                                                   from "../../modules/validation";
import {email, maxLength, minLength, numeric, required, requiredIf} from "vuelidate/lib/validators";
import YubinBango                                                   from "../../modules/yubinbango";

const duplicateWith    = (mainEmail) => (email) => !mainEmail || !email || mainEmail !== email;
const duplicateInArray = (emails) => (email) => !email || emails.filter(e => e === email).length <= 1;

export default {
  name  : 'ContractFormSend',
  props : ['value', 'corporation', 'account', 'activated'],
  mixins: [CommonMixin, ContractFormMixin, validationMixin],
  data  : () => ({
    common           : Common,
    billingViaWithFee: Common.billingViaWithFee,
    prefectures      : Common.prefectures,
    billMethod       : Common.billingMethodCreditCard,
    form             : {
      bill_via         : Common.billingViaEmail,
      name1            : null,
      name2            : null,
      name3            : null,
      postal           : null,
      email            : null,
      additionalAddresses: [null],
      pref             : null,
      city             : null,
      street_name      : null,
      street_number    : null,
      etc              : null,
      isSameCorporation: false,
    },
    errors           : {
      bill_via     : {
        required: Validation.errorMessage(Validation.rules.required, 'paymentBillVia'),
      },
      name1        : {
        required: Validation.errorMessage(Validation.rules.required, 'paymentName1'),
      },
      postal       : {
        requiredIf: Validation.errorMessage(Validation.rules.requiredIf, 'paymentPostal'),
        numeric   : Validation.errorMessage(Validation.rules.numeric, 'paymentPostal'),
        minLength : Validation.errorMessage(Validation.rules.size, 'paymentPostal'),
        maxLength : Validation.errorMessage(Validation.rules.size, 'paymentPostal'),
      },
      pref         : {
        requiredIf: Validation.errorMessage(Validation.rules.requiredIf, 'paymentPref'),
      },
      city         : {
        requiredIf: Validation.errorMessage(Validation.rules.requiredIf, 'paymentCity'),
      },
      street_name  : {
        requiredIf: Validation.errorMessage(Validation.rules.requiredIf, 'paymentStreetName'),
      },
      street_number: {
        requiredIf: Validation.errorMessage(Validation.rules.requiredIf, 'paymentStreetNumber'),
      },
      email        : {
        required: Validation.errorMessage(Validation.rules.required, 'paymentEmail'),
        email   : Validation.errorMessage(Validation.rules.email, 'paymentEmail'),
      },
    },
  }),
  validations() {
    return {
      form: {
        bill_via     : {
          required,
        },
        name1        : {
          required,
        },
        postal       : {
          requiredIf: requiredIf(() => {
            return this.form.bill_via !== Common.billingViaEmail;
          }),
          numeric,
          minLength : minLength(7),
          maxLength : maxLength(7),
        },
        pref         : {
          requiredIf: requiredIf(() => {
            return this.form.bill_via !== Common.billingViaEmail;
          }),
        },
        city         : {
          requiredIf: requiredIf(() => {
            return this.form.bill_via !== Common.billingViaEmail;
          }),
        },
        street_name  : {
          requiredIf: requiredIf(() => {
            return this.form.bill_via !== Common.billingViaEmail;
          }),
        },
        street_number: {
          requiredIf: requiredIf(() => {
            return this.form.bill_via !== Common.billingViaEmail;
          }),
        },
        email        : {
          required,
          email,
        },
        additionalAddresses: {
          maxLength: maxLength(10),
          $each    : {
            email,
            duplicateWith: duplicateWith(this.form.email),
            duplicate    : duplicateInArray(this.form.additionalAddresses),
          },
        },
      },
    };
  },
  methods: {
    showViaItem: function (item) {
      return this.billMethod !== Common.billingMethodCreditCard || item === Common.billingViaEmail;
    },
    toggleSameCorporation() {
      this.form.isSameCorporation = !this.form.isSameCorporation;
    },
    copyCorporationInformation: function () {
      if (this.form.isSameCorporation) {
        this.form.postal        = this.corporation.postal;
        this.form.pref          = this.corporation.pref;
        this.form.city          = this.corporation.city;
        this.form.street_name   = this.corporation.street_name;
        this.form.street_number = this.corporation.street_number;
        this.form.etc           = this.corporation.etc;
        this.form.email         = this.account.email;
      }
    },
    changeBillMethod(billMethod) {
      this.billMethod = billMethod;
      if (this.billMethod === Common.billingMethodCreditCard) {
        this.form.bill_via = Common.billingViaEmail;
      }
    },
    addNewEmail(atIndex) {
      if (this.form.additionalAddresses.length >= 10) {
        return null;
      }
      this.form.additionalAddresses.splice(atIndex, 0, null);
      this.$v.form.additionalAddresses.$reset()
      this.validateResponse = this.validateResponse.filter(item => !item['target'].startsWith('additional_addresses'))
    },
    removeThisEmail(atIndex) {
      this.form.additionalAddresses.splice(atIndex, 1);
      this.$v.form.additionalAddresses.$reset()
      this.validateResponse = this.validateResponse.filter(item => !item['target'].startsWith('additional_addresses'))
    },
    getEmailValidationClass(index) {
      if (!this.$v.form.additionalAddresses) {
        return null;
      }
      if (!this.$v.form.additionalAddresses.$each[index]) {
        return null;
      }
      const emailValidate = this.$v.form.additionalAddresses.$each[index];
      if (emailValidate.$invalid === true && emailValidate.$dirty === true) {
        return {
          'md-invalid': true,
        }
      }
      const responseMessage = this.getEmailValidationResponseMessage(index)
      return {
        'md-invalid': responseMessage !== null,
      }
    },
    getEmailValidationResponseMessage(index) {
      return this.getValidationResponseMessage('additional_addresses.' + index)
    },
  },
  watch  : {
    'form.isSameCorporation': function () {
      this.copyCorporationInformation();
    },
    "form.postal"           : function (pCode) {
      if (!pCode) {
        this.form.postal = '';
        return false;
      }

      const field = this.$v.form['postal'];
      if (field.$invalid === true && field.$dirty === true) {
        return;
      }
      let _this = this;
      new YubinBango.Core(pCode, function (addr) {
        if (addr.region.length === 0) {
          return;
        }
        if ((_this.form.city !== null && _this.form.city !== '')
            || (_this.form.street_name !== null && _this.form.street_name !== ''
            )) {
          return;
        }
        _this.form.pref        = addr.region;
        _this.form.city        = addr.locality;
        _this.form.street_name = addr.street;
      });

      this.form.postal = pCode.match(/\d/ig) ? pCode.match(/\d/ig).join('') : '';
    },
  },
}
</script>

<style lang="scss" scoped>
.md-form-title {
  align-items: baseline;
  margin-top: 28px;
}
</style>
